interface Props {
    cb: () => void;
    requiredTime?: number;
    requiredScrollPercent?: number;
    logging: boolean;
}

export class ClaritySession {
    private clicked = false;
    private timeout = false;
    private scrolled = false;
    cb: () => void;
    requiredScrollPercent: number;
    logging: boolean;

    constructor({
        cb,
        requiredTime = 30000,
        requiredScrollPercent = 30,
        logging = false,
    }: Props) {
        this.cb = cb;
        this.requiredScrollPercent = requiredScrollPercent;
        this.logging = logging;
        this.clickEvent = this.clickEvent.bind(this);
        this.scrollEvent = this.scrollEvent.bind(this);
        document.addEventListener('click', this.clickEvent);
        document.addEventListener('scroll', this.scrollEvent);
        setTimeout(this.timeoutEvent.bind(this), requiredTime);
    }

    private clickEvent() {
        this.clicked = true;
        if (this.logging) console.log('Click event detected');
        this.checkAll();
    }

    private timeoutEvent() {
        if (this.logging) console.log('Timeout event occurred');
        this.timeout = true;
        this.checkAll();
    }

    private scrollEvent() {
        const scrollTop = window.scrollY;
        const docHeight = document.body.offsetHeight;
        const winHeight = window.innerHeight;
        const scrollPercent = (scrollTop / (docHeight - winHeight)) * 100;
        if (scrollPercent > this.requiredScrollPercent) {
            if (this.logging) console.log('Scroll event reached');
            this.scrolled = true;
            document.removeEventListener('scroll', this.scrollEvent);
            this.checkAll();
        }
    }

    private checkAll() {
        if (this.clicked && this.timeout && this.scrolled) {
            try {
                this.cb();
            } catch (e) {
                console.error('ClaritySession: trigger is not a function');
            }
        }
    }
}
